import { gql } from "@apollo/client";

export const DashboardTask = gql`
  fragment DashboardTask on DashboardTask {
    taskOwnerId
    taskOwnerName
    taskId
    taskName
    taskType
    startDate
    startTime
    endTime
    priority
    status
    assignedUsers
    assignedGroups
    systemId
    folderId
    notes
    methodId
    startTimeScheduled
    endTimeScheduled
    startTimeActual
    endTimeActual
    project
    sampleType
  }
`;

export const PersonalTask = gql`
  fragment PersonalTask on PersonalTask {
    taskOwnerId
    taskId
    taskName
    startTimeScheduled
    endTimeScheduled
    priority
    status
    users {
      userId
    }
    groups {
      groupId
    }
    systemAssignedTo
    notes
  }
`;
